import { render, staticRenderFns } from "./CTimeButtonsAddDiy.vue?vue&type=template&id=63b0e2b7&scoped=true"
import script from "./CTimeButtonsAddDiy.vue?vue&type=script&lang=js"
export * from "./CTimeButtonsAddDiy.vue?vue&type=script&lang=js"
import style0 from "./CTimeButtonsAddDiy.vue?vue&type=style&index=0&id=63b0e2b7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b0e2b7",
  null
  
)

export default component.exports